import React from "react";
import { Link } from "react-router-dom";

const PortfolioCard = ({ image }) => {
  const { id, imageUrl, name } = image;
  return (
    <div className="w-full shadow-xl flex flex-col p-4 my-4 rounded-lg hover:scale-105 duration-300">
      <div className="text-center m-4 border-2 rounded-md">
        <div className="overflow-hidden rounded-md">
          <Link to={`portfolio/${id}`} state={{ image }}>
            <img
              className="hover:scale-125 transition-all duration-500 cursor-pointer object-cover h-48 w-96"
              src={imageUrl}
              alt={name}
              loading="lazy"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;
